import type { Statement } from '../types';
import { pct, score } from '../lib/format';

export function BridgeFeed({ statements }: { statements: Statement[] }) {
  const top = statements.filter((statement) => statement.bridgeScore > 0).slice(0, 6);
  return (
    <aside className="card bridgeFeed">
      <span className="eyebrow">Payoff</span>
      <h2>Surprising agreement</h2>
      {top.length === 0 ? (
        <p className="empty">No bridge has warmed yet. Vote from both sides to light one up.</p>
      ) : (
        <ol>
          {top.map((statement) => (
            <li key={statement.id}>
              <div>
                <b>{score(statement.bridgeScore)}</b>
                <span>bridge score</span>
              </div>
              <p>{statement.text}</p>
              <small>
                cross-consensus {pct(statement.crossConsensus)} · surprise {pct(statement.surprise)} · A/B {statement.nA}/{statement.nB}
              </small>
            </li>
          ))}
        </ol>
      )}
    </aside>
  );
}
